import React, {useRef, useEffect, useState} from "react";
import {motion, AnimatePresence} from "framer-motion";

const DIAGONAL_X = 100;
const HORIZONTAL_LENGTH = 90;
const viewportWidth = window.innerWidth < 768
const CARD_WIDTH = viewportWidth ? window.innerWidth : 540;
const NODE_GAP = 450;
const foreignPadding = 20;
const blockPadding = 10;

const LINE_COLOR = "#A8C1FF";
const POINT_COLOR = "#286CFF";

export default function Roadmap({items}) {
    const [dragLeft, setDragLeft] = useState(0)
    const [mn, setMn] = useState(window.innerWidth <= 768 ? 6 : 5)
    const offsetY = 20;
    const cardRefs = useRef([]);
    const descRef = useRef([]);
    const mainTextRef = useRef([]);
    const [cardHeights, setCardHeights] = useState([]);
    const [cardHeights1, setCardHeights1] = useState([]);
    const [mainTextHeights, setMainTextHeights] = useState([]);
    const [svgHeight1, setSvgHeight1] = useState(0);
    const [activeIndexes, setActiveIndexes] = useState(() =>
        items.reduce((acc, item, i) => {
            acc[i] = !!item.open;
            return acc;
        }, {})
    );


    useEffect(() => {

        setSvgHeight1((Math.max(...mainTextHeights) + Math.max(...cardHeights1) + foreignPadding*2 + blockPadding * 2 + 1 + 2 * offsetY)*2)
    }, [mainTextHeights, cardHeights1])



    useEffect(() => {
        document.fonts.ready.then(() => {
            const mainTextHeights1 = mainTextRef.current.map(ref =>
                ref?.scrollHeight || 0
            );

            const heights1 = descRef.current.map(ref =>
                ref?.scrollHeight || 130
            );

            setCardHeights1(heights1);
            setMainTextHeights(mainTextHeights1);


             })
    }, []);





    const placedPositions = items.map((item, i) => {

        return {
        ...item,
        x: 100 + i * NODE_GAP,
        cardHeight: (cardHeights1[i] || 130) + 2 * offsetY,
        mainTextHeight: mainTextHeights[i] + blockPadding * 2 + 1,
    }});

    const maxCardHeight = Math.max(...cardHeights, 130);
    const svgHeight = 360;

    const centralLineStart = 50;
    const centralLineEnd =
        (placedPositions[placedPositions.length - 1]?.x || 0) +
        CARD_WIDTH +
        DIAGONAL_X +
        HORIZONTAL_LENGTH +
        100;

    const toggleCard = i =>

        setActiveIndexes(prev => ({...prev, [i]: !prev[i]}));

    /*
        /*
        * <motion.svg
                    width={centralLineEnd + 50}
                    height={svgHeight}
                    style={{ overflow: "visible" }}
                    animate={{ height: svgHeight }}
                    transition={{ duration: 0.4 }}
                >
        * */
    useEffect(() => {
        const draggableWidth = centralLineEnd + 50;
        const viewport = window.innerWidth;
        const minX = Math.min(0, viewport - draggableWidth);
        setDragLeft(minX);
    }, [centralLineEnd]);

    return (
        <motion.div className="svg_container">


            <motion.svg
                width={centralLineEnd + 50}
                height="400"
                style={{overflow: "visible", marginBottom:"30px"}}
                animate={{height: svgHeight}}
                transition={{duration: 0.4}}
            >
                <defs>
                    <linearGradient
                        id="roadmapStroke"
                        x1="0"
                        y1="0"
                        x2={centralLineEnd}
                        y2="0"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0%" stopColor="#EBF1FF"/>
                        <stop offset="100%" stopColor="#335CFF"/>
                    </linearGradient>
                </defs>

                {placedPositions.map((item, i) => {
                    const isCenter = !item.branch;
                    const isActive = activeIndexes[i];
                    const baseCardHeight = isActive ? cardHeights1[i] + foreignPadding*2 + item.mainTextHeight + 4  : item.mainTextHeight + foreignPadding*2


                    const cardHeight = baseCardHeight


                    const cardCenterOffset = cardHeight / 2;

                    const diagEndX = item.x + DIAGONAL_X;
                    const diagEndY = item.branch === "up"
                        ? svgHeight / 2 - cardCenterOffset
                        : item.branch === "down"
                            ? svgHeight / 2 + cardCenterOffset
                            : svgHeight / 2;

                    const horEndX = diagEndX + HORIZONTAL_LENGTH;
                    const horEndY = diagEndY;

                    const cardX = isCenter ? item.x - CARD_WIDTH / 2 : horEndX + 10;
                    const cardY = diagEndY - cardCenterOffset;

                    const pointX = isCenter ? item.x : horEndX;
                    const pointY = diagEndY;
                    const cardWidth = CARD_WIDTH;
                    return (
                        <g key={i}>
                            {item.branch && (
                                <motion.line
                                    x1={item.x}
                                    y1={svgHeight / 2}
                                    x2={diagEndX}
                                    y2={diagEndY + 20}
                                    stroke={LINE_COLOR}
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                    animate={{y2: diagEndY}}
                                    transition={{duration: 0.4}}
                                />
                            )}

                            {item.branch && (
                                <motion.line
                                    x1={diagEndX}
                                    y1={diagEndY}
                                    x2={horEndX}
                                    y2={horEndY}
                                    stroke={LINE_COLOR}
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                    animate={{y1: diagEndY, y2: horEndY}}
                                    transition={{duration: 0.4}}
                                />
                            )}

                            <motion.circle
                                cx={pointX}
                                cy={pointY }
                                r="10"
                                fill="#fff"
                                stroke={POINT_COLOR}
                                strokeWidth="4"
                                animate={{cy: pointY}}
                                transition={{duration: 0.4}}
                            />

                            <motion.foreignObject
                                x={cardX}
                                y="0"
                                width={CARD_WIDTH} // начальная ширина
                                height={cardHeight}
                                maxHeight={cardHeight}
                                onClick={() => toggleCard(i)}
                                style={{overflow: "hidden", cursor: "pointer", minHeight: "88px", maxWidth: "100vw"}}
                                animate={{
                                    height: cardHeight,
                                    y: cardY,
                                    width: cardWidth
                                }}
                                transition={{duration: 0.4}}
                            >
                                <motion.div
                                    ref={el => (cardRefs.current[i] = el)}
                                    className={`roadmap_point ${isActive ? "active" : ""}`}
                                    style={{
                                        background: "white",
                                        borderRadius: 14,
                                        padding: "10px 16px",
                                        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
                                        border: "1px solid #E8EBF3",
                                        fontFamily: "Inter, sans-serif",
                                        textAlign: isCenter ? "center" : "left",
                                        height: "100%",
                                        overflow: "hidden",
                                        maxHeight: "max-content"
                                    }}
                                >
                                    <div className="roadmap_point_info">
                                        <div
                                            ref={el => (mainTextRef.current[i] = el)}
                                        >{item.date}</div>
                                        <motion.div
                                            className="roadmap_point_desc"
                                            ref={el => (descRef.current[i] = el)}
                                            initial={{maxHeight: 0, opacity: 0}}
                                            animate={isActive ? {
                                                //marginTop:"4px",
                                                maxHeight: cardHeight - 88,
                                                opacity: 1
                                            } : {maxHeight: 0, opacity: 0}}
                                            transition={{duration: 0.4}}
                                            style={{overflow: "hidden"}}
                                        >
                                            {item.label}
                                        </motion.div>
                                    </div>
                                </motion.div>
                            </motion.foreignObject>
                        </g>
                    );
                })}

                <line
                    x1={centralLineStart}
                    y1={svgHeight / 2}
                    x2={centralLineEnd}
                    y2={svgHeight / 2}
                    stroke="url(#roadmapStroke)"
                    strokeWidth="4"
                />
            </motion.svg>
        </motion.div>
    );
}